'use strict';

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var SoaModel = require('bunsen/models/SoaModel');
var extendCompose = require('bunsen/libraries/extendCompose');
var Conversation = module.exports = extendCompose.call(SoaModel, {});
var Anchors = require('bunsen/collections/Anchors');
var AnchorLists = require('bunsen/collections/identity/AnchorLists');
var Messages = require('bunsen/collections/usercomm/Messages');
var Item = require('bunsen/models/inventory/Item');
var Transaction = require('bunsen/models/ecomm/Transaction');
var BuyerProfile = require('../BuyerProfile');
var Party = require('bunsen/models/Party');
var User = require('bunsen/models/identity/User');
var endpoints = require('dibs-endpoints');
var Clump = require('bunsen/libraries/clump');
var bunsen = require('bunsen/libraries/bunsen');
var newsy = require('newsy');
var globalDataLogger = require('bunsen/libraries/globalDataLogger');
var Deferred = require('simply-deferred').Deferred;
var Qs = require('qs');
var assign = require('lodash.assign');
var copyText = require('copy-text')();
/**
 * @attribute unreadMessagesCount - total number of unread messages in this conversation
 * @attribute numberOfAttachments
 */
Conversation.extendSelf({
    url: function (options) {
        options = options || {};
        if (this._asUser) {
            options.params = assign({}, options.params, {userId: this._asUser});
        }
        if (undefined === this.id || 'undefined' === this.id) {
            globalDataLogger.event({'conversation id is undefined': this.toJSON()});
            globalDataLogger.flush();
        }
        return endpoints.conversation(this.id, options);
    },
    sync: function (method, context, options) {
        var fields;
        if (method !== 'read') {
            return Conversation.__super__.sync.apply(this, arguments);
        }
        // make sure that conversation is always requested with at least baseFields
        options = _.extend({}, options);
        if (!options.data) {
            options.data = {};
        }
        fields = _.result(options.data, 'fields');
        if ("string" === typeof fields) {
            fields = fields.split(',');
        }
        if (!_.isArray(fields)) {
            fields = [];
        }
        options.data = _.extend({}, options.data, {fields: _.uniq(fields.concat(Conversation.baseFields)).join(',')});
        return Conversation.__super__.sync.call(this, method, context, options);
    },
    initialize : function (attributes, options) {
        options = assign({
            asUser: undefined
        }, options);
        this.on('sync', function (model, data) {
            globalDataLogger.event({'conversation model sync': data});
        });
        this._asUser = options.asUser;
    },
    _getLatestMessageSenderId: function () {
        return parseInt(this.get('latestMessageSenderId'), 10); // TODO: get services to be consistent between types in their ids, then remove the parseInt (and this method);
    },
    getLatestMessageRecipientDisplayName: function () {
        var latestMessageRecipient = _.last(this.get('members').filter(function (recipient) {
            if ('N' === recipient.get('isActive')) {
                return false;
            }
            if (recipient.isExternal()) {
                return false;
            }
            return recipient.id !== this._getLatestMessageSenderId();
        }, this));
        if (latestMessageRecipient) {
            return latestMessageRecipient.getDisplayName();
        }
        return copyText.get('unknownRecipient');
    },
    getOtherMemberDisplayName: function () {
        var displayName = '';
        if (this.getOtherMember) {
            displayName = _.result(this.getOtherMember(), 'getDisplayName');
        }
        return displayName;
    },
    parse : function () {
        var data = Conversation.__super__.parse.apply(this, arguments);
        if ("string" === typeof data.isLatestMessageSender) {
            data.isLatestMessageSender = data.isLatestMessageSender === 'Y';
        }
        return data;
    },
    idAttribute : "id",
    defaults : {
        members : [],
        anchors : []
    },
    relations: [
        {
            key: 'reviewedBy',
            relatedModel: User,
            type: Backbone.One
        },
        {
            key: 'messagePointers',
            relatedModel: SoaModel,
            type: Backbone.One
        },
        {
            key : 'anchors',
            collectionType: Anchors,
            type : Backbone.Many
        },
        {
            key : 'members',
            relatedModel: newsy.getConstructor.bind(newsy, 'ConversationMember'),
            type : Backbone.Many
        },
        {
            key : 'messages',
            omitFromSave: true,
            collectionType: Messages,
            type : Backbone.Many
        },
        {
            key: 'item',
            omitFromSave: true,
            relatedModel: Item,
            type: Backbone.One
        },
        {
            key: 'transaction',
            relatedModel: Transaction,
            type: Backbone.One
        },
        {
            key: 'buyerProfile',
            relatedModel: BuyerProfile,
            type: Backbone.One
        }
    ],
    fetchMessages : function () {
        var messages = this.get('messages') || new Messages();
        var dummyConversation = newsy('ConversationModel', _.pick(this, 'id'));
        this.set('messages', messages);
        globalDataLogger.event({'created dummy conversation': dummyConversation.toJSON()});
        return dummyConversation.fetch({data: {fields: ['message', 'attachment'].join(',')}}).then(function (data) {
            var newMessages;
            globalDataLogger.event({'fetched dummy conversation': data});
            newMessages = dummyConversation.get('messages');
            if (!newMessages) {
                return Deferred().reject();
            }
            messages.reset(newMessages.models);
        });
    },
    markReadUnread : function (isRead) {
        if (undefined === isRead) {
            isRead = true;
        }
        _.result(this._lastMarkReadUnreadRequest, 'abort');
        this._lastMarkReadUnreadRequest = Clump.ajax({
            type : "PUT",
            url : endpoints.markReadUnread + '?' + Qs.stringify(_.extend({
                isRead : isRead === true || isRead === 'Y' ? 'Y' : 'N',
                conversationIds : this.id
            }, bunsen.getToken()))
        });
        return this._lastMarkReadUnreadRequest;
    },
    getMemberForUser: function (options) {
        options = _.extend({
            userId: undefined
        }, options);
        if (!options.userId) {
            throw new Error('getMemberForUser expects options.userId');
        }
        return _.first(this.get('members').filter(function (member) {
            return member.get('user').id === options.userId;
        }));
    },
    getMostRecentMessage: function () {
        return _.result(this.get('messages'), 'last');
    },
    getOriginalBuyer: function () {
        return this.getOriginalMemberByType(Party.ROLE_BUYER);
    },
    getOriginalSeller: function () {
        return this.getOriginalMemberByType(Party.ROLE_SELLER);
    },
    getOriginalMemberByType: function (type) {
        return this.get('members').findWhere({
            userType: type,
            isOriginal: 'Y'
        });
    },
    isUnavailable: function () {
        return this.get('status') !== 'ACTIVE';
    },
    isContentRedacted: function () {
        return this.get('messageContentRedacted') === 'Y';
    },
    getUrlForBuyerAndItemEndpoint: function (options) {
        return endpoints.conversationsForBuyerAndItemUrl({
            buyerId: options.buyerId,
            itemId: options.itemId
        });
    },
    fetchConversationForBuyerAndItem: function (options) {
        return this.fetch({url: this.getUrlForBuyerAndItemEndpoint(options)});
    },
    getLatestDealerOffer: function () {
        var offers = this.get('transaction.offers');
        if (offers) {
            return _.last(offers.filter(function (offer) {
                return offer.get('initiatingParty.role') === Party.ROLE_SELLER;
            }));
        }
    },
    getReviewReasons: function () {
        if (!this.get('reviewReason')) {
            return [];
        }
        return this.get('reviewReason').split(',').map(function (reason) {
            return reason.trim();
        });
    },
    isSellerOnNewPolicy: function () {
        var seller = this.getOriginalSeller();
        var sellerId = seller.get('user').id;
        var anchorLists = new AnchorLists();

        return anchorLists.fetchListForSellerPolicy(sellerId).then(function (data) {
            if (data.result.length) {
                return !!_.findWhere(data.result, {name: AnchorLists.listNames.OPOP});
            }
        });
    }
});
Conversation.reviewStatuses = [
    'OPEN',
    'MONITORING',
    'IN_PROGRESS',
    'CLOSED'
];
Conversation.baseFields = [
    'conv_trans_full', // transaction in conversation will return the most relevant transaction
    'OFFER' // offers in messages
];
Conversation.newsy = {
    builds: ['ConversationMember'],
    name: 'ConversationModel'
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/usercomm/Conversation.js
// module id = 131
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54